import React, { useContext } from 'react'

interface IOfferGridContext {
  openedColumns: Array<any>
  onSectionTitleClick: Function
  risks: ISelectedRisk[]
  setRisks: (selectedRisk: ISelectedRisk[]) => void
}

export interface ISelectedRisk {
  riskId: number,
  selected: boolean | null,
  addable: boolean
}

interface IOfferGridProvider {
  openedColumns: any
  onSectionTitleClick: Function
  children?: React.ReactNode

  risks: ISelectedRisk[]
  setRisks: (selectedRisks: ISelectedRisk[]) => void
}

const defaultState = {
  openedColumns: [],
  onSectionTitleClick: () => { },
  risks: [],
  setRisks: () => { }
}

const OfferGridContext = React.createContext<IOfferGridContext>(defaultState)

export const OfferGridProvider = ({
  openedColumns,
  onSectionTitleClick,
  risks,
  setRisks,
  children,
}: IOfferGridProvider) => {


  return (
    <OfferGridContext.Provider
      value={{
        risks: risks,
        setRisks: setRisks,
        openedColumns,
        onSectionTitleClick,
      }}
    >
      {children && children}
    </OfferGridContext.Provider>
  )
}

export const useOfferGrid = () => {
  const context = useContext(OfferGridContext)

  if (context === undefined || Object.keys(context).length == 0) {
    throw new Error('useOfferGrid must be used within a OfferGridProvider!')
  }

  return context
}
